(() => {
    // ---- w_view_item: push product data to dataLayer once per page load ----
    window.dataLayer = window.dataLayer || [];
    document.querySelectorAll('[data-view-item-payload]').forEach(node => {
        try {
            const payload = JSON.parse(node.textContent);
            window.dataLayer.push({ ecommerce: null }); // clear previous ecommerce object first
            window.dataLayer.push(payload);
        } catch (err) {
            console.error('w_view_item: could not parse product payload', err);
        }
    });

    document.querySelectorAll('.pdp-buy-box').forEach(section => {
        // ---- gallery thumbnails: click to swap main image, with a fade transition ----
        const mainImg = section.querySelector('[id^="pdp-main-image-"]');
        section.querySelectorAll('[data-thumb]').forEach(btn => {
            btn.addEventListener('click', () => {
                if (!mainImg) return;

                // Fade out, swap the src/srcset, fade back in once the new
                // image has actually finished loading (not just once we've
                // set the attribute) so the animation matches real load time.
                mainImg.classList.add('is-loading');

                const onLoad = () => {
                    mainImg.classList.remove('is-loading');
                    mainImg.removeEventListener('load', onLoad);
                };
                mainImg.addEventListener('load', onLoad);

                // srcset takes priority over src when both are present, so it
                // must be updated to match, or the browser ignores the new src.
                if (btn.dataset.srcset) {
                    mainImg.srcset = btn.dataset.srcset;
                } else {
                    mainImg.removeAttribute('srcset');
                }
                mainImg.removeAttribute('sizes');
                mainImg.src = btn.dataset.src;
            });
        });

        // ---- thumb-strip carousel: peek/fade edges + prev/next nav ----
        // Shows a fixed window of thumbs (6 desktop / 4 mobile, set via CSS
        // custom properties on .pdp-buy-box__thumbs-wrap). When there's more
        // content past an edge, that edge gets a mask-image fade and its
        // nav arrow appears. Axis-agnostic: reads the track's actual
        // flex-direction so it works whether the CSS has it as a vertical
        // column (desktop) or horizontal row (mobile).
        const thumbsWrap = section.querySelector('[data-thumbs-wrap]');
        const thumbsTrack = section.querySelector('[data-thumbs-track]');
        if (thumbsWrap && thumbsTrack) {
            const prevBtn = thumbsWrap.querySelector('[data-thumb-nav="prev"]');
            const nextBtn = thumbsWrap.querySelector('[data-thumb-nav="next"]');
            const isHorizontal = () => getComputedStyle(thumbsTrack).flexDirection === 'row';

            const updateNav = () => {
                const horizontal = isHorizontal();
                const pos = horizontal ? thumbsTrack.scrollLeft : thumbsTrack.scrollTop;
                const size = horizontal ? thumbsTrack.scrollWidth : thumbsTrack.scrollHeight;
                const client = horizontal ? thumbsTrack.clientWidth : thumbsTrack.clientHeight;
                thumbsWrap.classList.toggle('has-more-above', pos > 2);
                thumbsWrap.classList.toggle('has-more-below', pos < size - client - 2);
            };

            const step = () => {
                const thumb = thumbsTrack.querySelector('.pdp-buy-box__thumb');
                if (!thumb) return 100;
                const rect = thumb.getBoundingClientRect();
                return (isHorizontal() ? rect.width : rect.height) + 12;
            };

            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    const amount = step();
                    thumbsTrack.scrollBy(isHorizontal() ? { left: -amount, behavior: 'smooth' } : { top: -amount, behavior: 'smooth' });
                });
            }
            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    const amount = step();
                    thumbsTrack.scrollBy(isHorizontal() ? { left: amount, behavior: 'smooth' } : { top: amount, behavior: 'smooth' });
                });
            }

            thumbsTrack.addEventListener('scroll', updateNav);
            window.addEventListener('resize', updateNav);
            updateNav();
        }

        // ---- free shipping bar: reads live cart total via /cart.js ----
        // Returns a refresh() function so the add-to-cart handler below can
        // re-check the bar right after an item is added, without a full
        // page reload.
        const setupShippingBar = () => {
            const bar = section.querySelector('[data-shipping-bar]');
            if (!bar) return null;

            const threshold = parseFloat(bar.dataset.threshold) || 0;
            const deliveryDays = parseInt(bar.dataset.deliveryDays, 10) || 3;
            const progressTemplate = bar.dataset.progressText || 'Add [amount] more for free shipping';
            const metText = bar.dataset.metText || 'FREE delivery';
            const fill = bar.querySelector('[data-shipping-progress-fill]');
            const msg = bar.querySelector('[data-shipping-msg]');

            const formatMoney = (amount, currency) => {
                try {
                    return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
                } catch (err) {
                    return '$' + amount.toFixed(2);
                }
            };

            // Business-day estimate: counts forward from today, skipping
            // Saturdays and Sundays, until deliveryDays business days have
            // been added.
            const formatDeliveryDate = () => {
                const d = new Date();
                let remaining = deliveryDays;
                while (remaining > 0) {
                    d.setDate(d.getDate() + 1);
                    const day = d.getDay(); // 0 = Sunday, 6 = Saturday
                    if (day !== 0 && day !== 6) remaining--;
                }
                const weekday = d.toLocaleDateString(undefined, { weekday: 'long' });
                const day = d.getDate();
                const suffix = (day % 10 === 1 && day !== 11) ? 'st'
                    : (day % 10 === 2 && day !== 12) ? 'nd'
                    : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
                const month = d.toLocaleDateString(undefined, { month: 'long' });
                return `${weekday} ${day}${suffix} ${month}`;
            };

            const render = (cartTotal, currency) => {
                if (threshold <= 0 || cartTotal >= threshold) {
                    bar.classList.add('is-met');
                    if (fill) fill.style.width = '100%';
                    if (msg) msg.innerHTML = `<strong>${metText}</strong> ${formatDeliveryDate()}`;
                } else {
                    bar.classList.remove('is-met');
                    const remaining = threshold - cartTotal;
                    const pct = Math.max(0, Math.min(100, (cartTotal / threshold) * 100));
                    if (fill) fill.style.width = pct + '%';
                    if (msg) msg.textContent = progressTemplate.replace('[amount]', formatMoney(remaining, currency));
                }
            };

            const refresh = () => {
                fetch('/cart.js', { credentials: 'same-origin' })
                    .then(res => res.json())
                    .then(cart => render(cart.total_price / 100, cart.currency))
                    .catch(() => {});
            };

            refresh();
            return { refresh, render: (cart) => render(cart.total_price / 100, cart.currency) };
        };
        const shippingBar = setupShippingBar();

        // ---- add to cart: AJAX submit with a loading-dots state on the
        // button, since a full-page redirect made the button look inert
        // for the second or so the request takes. On success: one /cart.js
        // fetch feeds both the shipping bar and the site-wide cart icon
        // badge (previously these fired as two separate requests), then
        // either open the Rebuy Smart Cart drawer (if present on this
        // page) or fall back to navigating to /cart — that part doesn't
        // wait on the cart.js fetch at all, so it's not held up by it. ----
        const cartForm = section.querySelector('form[data-ajax-cart-form]');
        const cartSubmitBtn = section.querySelector('.pdp-buy-box__submit');

        // ---- offer code: attach a discount code to the cart after add to cart ----
        // Configured in the section settings ("Discount code on add to cart")
        // and passed in as data attributes on the form. Resolution order,
        // URL first:
        //   1. ?code=XYZ (only if "Allow a code from the URL" is on)
        //   2. ?offer=code             -> the section's code
        //   3. ?offer=<anything else>  -> no code, even on an "Always" page
        //   4. mode "always"           -> the section's code
        //   5. mode "url"              -> a code remembered from an earlier
        //      ?offer=code landing in this browser session
        // Resolved once on page load so the landing URL is remembered even if
        // the visitor adds to cart after a reload or a return visit in the
        // same tab.
        const OFFER_STORAGE_KEY = 'qott_offer_code';
        const offerStorage = {
            get() { try { return window.sessionStorage.getItem(OFFER_STORAGE_KEY) || ''; } catch (err) { return ''; } },
            set(value) { try { window.sessionStorage.setItem(OFFER_STORAGE_KEY, value); } catch (err) {} },
            clear() { try { window.sessionStorage.removeItem(OFFER_STORAGE_KEY); } catch (err) {} },
        };

        const resolveOfferCode = (form) => {
            if (!form) return '';
            const sectionCode = (form.dataset.offerCode || '').trim();
            const mode = form.dataset.offerMode || 'url';
            const allowUrlCode = form.dataset.offerAllowUrlCode === 'true';
            if (!sectionCode && !allowUrlCode) return ''; // feature off

            const params = new URLSearchParams(window.location.search);
            const offerParam = (params.get('offer') || '').trim().toLowerCase();
            const urlCode = allowUrlCode ? (params.get('code') || '').trim() : '';

            if (urlCode) {
                offerStorage.set(urlCode);
                return urlCode;
            }
            if (offerParam === 'code') {
                if (sectionCode) offerStorage.set(sectionCode);
                return sectionCode;
            }
            if (offerParam) {
                offerStorage.clear();
                return '';
            }
            if (mode === 'always') return sectionCode;
            return offerStorage.get();
        };
        const offerCode = resolveOfferCode(cartForm);

        // Adds the code to the cart via the Ajax Cart API. /cart/update.js's
        // `discount` parameter REPLACES all codes on the cart, so read the
        // current codes first and merge. Resolves with the updated cart JSON.
        const attachOfferCode = async (code, form) => {
            const cartJsUrl = (form.dataset.cartUrl || '/cart') + '.js';
            const updateUrl = (form.dataset.cartUpdateUrl || '/cart/update') + '.js';

            const cartRes = await fetch(cartJsUrl, {
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json' },
            });
            const cart = await cartRes.json();
            const existing = (cart.discount_codes || []).map(d => d && d.code).filter(Boolean);
            if (existing.some(c => c.toUpperCase() === code.toUpperCase())) return cart;

            const updateRes = await fetch(updateUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ discount: existing.concat(code).join(',') }),
            });
            const updated = await updateRes.json();
            if (!updateRes.ok || updated.status) {
                throw new Error(updated.description || updated.message || 'Could not apply discount code');
            }

            // Shopify accepts any code string; `applicable: false` means the
            // code exists on the cart but doesn't apply (expired, wrong
            // product, customer eligibility, combination rules, etc.).
            const applied = (updated.discount_codes || []).find(d => d && d.code && d.code.toUpperCase() === code.toUpperCase());
            if (!applied || applied.applicable === false) {
                console.warn(`pdp-buy-box: discount code "${code}" was added but is not applicable to this cart`);
            }
            return updated;
        };

        if (cartForm && cartSubmitBtn) {
            cartForm.addEventListener('submit', (e) => {
                e.preventDefault();
                if (cartSubmitBtn.classList.contains('is-loading')) return;

                cartSubmitBtn.classList.add('is-loading');
                const addUrl = cartForm.dataset.cartAddUrl || '/cart/add.js';
                const cartUrl = cartForm.dataset.cartUrl || '/cart';

                fetch(addUrl, {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: new FormData(cartForm),
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.status) {
                            // Shopify returns { status, message, description } on error
                            throw new Error(data.description || data.message || 'Could not add to cart');
                        }

                        // Badge refresh is now handled globally by
                        // campaign-cart-icon.js's fetch interceptor, which
                        // catches this /cart/add.js call (and the
                        // /cart/update.js call below) automatically — no
                        // need to fetch /cart.js a second time here just
                        // for that. The shipping bar still needs its own
                        // read of the cart total, though.
                        //
                        // If an offer code applies, attach it before the
                        // drawer opens so the saving is already visible.
                        // A failed code never blocks the add: the product
                        // is in the cart either way.
                        const afterAdd = offerCode
                            ? attachOfferCode(offerCode, cartForm).catch(err => {
                                console.warn('pdp-buy-box: could not attach offer code', err);
                                return null;
                            })
                            : Promise.resolve(null);

                        return afterAdd.then(updatedCart => {
                            if (shippingBar) {
                                if (updatedCart) shippingBar.render(updatedCart);
                                else shippingBar.refresh();
                            }

                            const openCart = () => {
                                if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
                                    window.Rebuy.SmartCart.show();
                                } else {
                                    window.location.href = cartUrl;
                                }
                            };

                            // Ask Rebuy to re-read the cart so its drawer
                            // shows the discount line, when that API exists.
                            const rebuyCart = window.Rebuy && window.Rebuy.Cart;
                            if (updatedCart && rebuyCart && typeof rebuyCart.fetchCart === 'function') {
                                return Promise.resolve()
                                    .then(() => rebuyCart.fetchCart())
                                    .catch(() => {})
                                    .then(openCart);
                            }
                            openCart();
                        });
                    })
                    .catch(err => {
                        console.error('pdp-buy-box: add to cart failed', err);
                        alert(err.message || 'Something went wrong adding this to your cart.');
                    })
                    .finally(() => {
                        cartSubmitBtn.classList.remove('is-loading');
                    });
            });
        }

        // ---- variant buttons ----
        const variantButtons = [...section.querySelectorAll('[data-variant-btn]')];
        if (!variantButtons.length) return;

        const idInput = section.querySelector('[data-variant-id-input]');
        const submitLabelEl = section.querySelector('[data-submit-label]');
        const priceEl = section.querySelector('[data-price]');
        const comparePriceEl = section.querySelector('[data-compare-price]');

        const selectVariant = (btn) => {
            variantButtons.forEach(b => b.classList.remove('is-selected'));
            btn.classList.add('is-selected');

            if (idInput) idInput.value = btn.dataset.variantId;

            const available = btn.dataset.available === 'true';
            if (cartSubmitBtn) cartSubmitBtn.disabled = !available;
            if (submitLabelEl) {
                submitLabelEl.textContent = available
                    ? (cartSubmitBtn && cartSubmitBtn.dataset.defaultLabel || 'Add to Cart')
                    : 'Sold Out';
            }

            if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
            if (comparePriceEl) {
                if (btn.dataset.comparePrice) {
                    comparePriceEl.textContent = btn.dataset.comparePrice;
                    comparePriceEl.style.display = '';
                } else {
                    comparePriceEl.style.display = 'none';
                }
            }
        };

        variantButtons.forEach(btn => {
            btn.addEventListener('click', () => selectVariant(btn));
        });
    });
})();
